import React from 'react';
import { ButtonWithGAClickButton, SecondarySection, SectionSubTitle } from 'common/components';
import { strictBreakpoints } from 'common/styles/breakpoints';
import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';
import {
  filterServices,
  filterServicesContent,
  filterServicesImage,
  filterServicesImageMobile,
  filterServicesWrapper,
} from './filter-services-styles';

type FilterServicesProps = {
  elementBlock: string;
  onConsultationSignupBtnClick: TFunction;
}

export const FilterServices: React.FC<FilterServicesProps> = ({ elementBlock, onConsultationSignupBtnClick }) => (
  <SecondarySection className={filterServices}>
    <div className={filterServicesWrapper}>
      <div className={filterServicesContent}>
        <SectionSubTitle as="h3" margin="s">
          Система фильтрации для загородного дома от&nbsp;61&nbsp;000&nbsp;₽
        </SectionSubTitle>

        <picture>
          <source srcSet={`${ENGINEERING_SYSTEMS_CDN_PATH}/filter/services/service-t.png/service-t.png`} media={strictBreakpoints['--only-tablet']} />
          <img
            alt="Перечень услуг"
            className={filterServicesImageMobile}
            src={`${ENGINEERING_SYSTEMS_CDN_PATH}/filter/services/service-m.png/service-m.png`}
          />
        </picture>

        <ButtonWithGAClickButton
          elementBlock={elementBlock}
          elementText="Записаться на консультацию"
          elementName="Система фильтрации для загородного дома от 61 000 ₽"
          onClick={onConsultationSignupBtnClick}
        >
          Записаться на консультацию
        </ButtonWithGAClickButton>
      </div>

      <picture>
        <source srcSet={`${ENGINEERING_SYSTEMS_CDN_PATH}/filter/services/service-ld.png/service-ld.png`} media={strictBreakpoints['--only-largeDesktop']} />
        <img
          alt="Перечень услуг"
          className={filterServicesImage}
          src={`${ENGINEERING_SYSTEMS_CDN_PATH}/filter/services/service-d.png/service-d.png`}
        />
      </picture>
    </div>
  </SecondarySection>
);
